// @ts-check
if (!customElements.get("ff-block-info")) {
  class FfBlockInfo extends HTMLElement {
    constructor() {
      super();
      if (!!this.dataset.ffSwiperEnabled) {
        this.ffAutoplay = !!this.dataset.ffAutoplay;

        // pagination styles
        this.ffDotsClass = this.dataset.ffDotsClass;
        this.ffDotClass = this.dataset.ffDotClass;
        this.ffDotActiveClass = this.dataset.ffDotActiveClass;

        this.ffLeftArrowClass = this.dataset.ffLeftArrowClass;
        this.ffRightArrowClass = this.dataset.ffRightArrowClass;
        this.ffDisabledArrowClass = this.dataset.ffDisabledArrowClass

        this.ffMobileBreakpoint = this.dataset.ffMobileBreakpoint;
        this.ffMobileItemsPerView = this.dataset.ffMobileItemsPerView;
        this.ffDesktopItemsPerView = this.dataset.ffDesktopItemsPerView;

        this.init();
      }
    }

    async init() {
      const swiperParams = {
        mousewheel: false,
        spaceBetween: 40,
        slidesPerView: this.dataset.ffMobileItemsPerView || 1,
      };

      if (this.ffAutoplay) {
        swiperParams.autoplay = {
          delay: 5000,
        };
      } else {
        swiperParams.autoplay = false;
      }

      if (this.ffDotsClass) {
        swiperParams.pagination = {
          el: `.${this.ffDotsClass}`,
          bulletClass: `${this.ffDotClass}`,
          bulletActiveClass: `${this.ffDotActiveClass}`,
          type: "bullets",
          clickable: true,
        };
      }

      if (this.ffLeftArrowClass && this.ffRightArrowClass) {
        swiperParams.navigation = {
          prevEl: `.${this.ffLeftArrowClass}`,
          nextEl: `.${this.ffRightArrowClass}`,
          disabledClass: `${this.ffDisabledArrowClass}`
        };
      }

      if (this.ffMobileBreakpoint) {
        swiperParams.breakpoints = {
          [this.ffMobileBreakpoint]: {
            slidesPerView: this.ffDesktopItemsPerView,
          },
        };
      }
      
      const swiper = new Swiper(".ff-block-info_content", swiperParams);
    }
  }

  customElements.define("ff-block-info", FfBlockInfo);
}
